import React, { FC } from 'react';

import { useShopConfig } from 'src/explore/hooks/useShopConfig';
import { CardFactory } from '../../../ProductGrid/services/CardFactory';

const factory = new CardFactory();

interface Props {
  analytics?: Record<string, string>;
  hideLove?: boolean;
  hideMerchant?: boolean;
  linkParameters?: {
    [key: string]: string;
  };
  products: Array<any>;
  recommId?: string | null;
  template: string;
}

export const Products: FC<Props> = ({
  analytics = {},
  hideLove,
  hideMerchant,
  linkParameters,
  products,
  recommId,
  template,
}) => {
  const config = useShopConfig();

  if ( !( products && products.length )) return null;

  const ProductCard = factory.create( template );

  return (
    <>
      {products.map(( product, i ) => {
        if ( !product ) return null;

        return (
          <ProductCard
            analytics={{
              ...analytics,
              click: `position: ${i + 1}${analytics.click ? `; ${analytics.click}` : ''}`,
            }}
            hideLove={hideLove || config.isWhitelabel}
            hideMerchant={hideMerchant}
            linkParameters={linkParameters}
            isWhitelabel={config.isWhitelabel}
            key={product.id}
            product={product}
            recommId={recommId}
          />
        );
      })}
    </>
  );
};
